// src/screens/VerificarEmail/VerificarEmail.js

import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { auth, db } from '../../firebaseconfig';
import { sendEmailVerification } from 'firebase/auth';
import { doc, updateDoc } from 'firebase/firestore';
import { useAuth } from '../../Context/AuthContext';
import './VerificarEmail.css';
import { FaEnvelopeOpenText } from 'react-icons/fa';

const VerificarEmail = () => {
    const { user, userData } = useAuth(); // Usamos o 'user' do nosso hook
    const navigate = useNavigate();
    const location = useLocation();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [resendDisabled, setResendDisabled] = useState(false);
    const [countdown, setCountdown] = useState(60);

    const email = location.state?.email || user?.email || 'seu e-mail';

    useEffect(() => {
        let timer;
        if (resendDisabled && countdown > 0) {
            timer = setInterval(() => {
                setCountdown(prev => prev - 1);
            }, 1000);
        } else if (countdown === 0) {
            setResendDisabled(false);
        }
        return () => clearInterval(timer);
    }, [resendDisabled, countdown]);

    const handleCheckVerification = async () => {
        setLoading(true);
        setError('');
        setSuccess('');
        
        // Usamos o 'user' do hook, mas recarregamos para pegar o status mais recente
        if (!user) {
            setError("Usuário não encontrado. Por favor, faça login novamente.");
            setLoading(false);
            return;
        }

        await user.reload();
        
        if (user.emailVerified) {
            const userDocRef = doc(db, "usuarios", user.uid);
            await updateDoc(userDocRef, { emailConfirmado: true });

            setSuccess("E-mail verificado com sucesso! Redirecionando...");
            setTimeout(() => {
                if (userData?.premium) {
                    navigate("/conta");
                } else {
                    navigate("/assinar");
                }
            }, 2500);
        } else {
            setError("E-mail ainda não verificado. Por favor, verifique sua caixa de entrada (incluindo spam).");
            setLoading(false);
        }
    };

    const handleResendEmail = async () => {
        if (resendDisabled || !user) return; // Usamos o 'user' do hook
        setError('');
        setSuccess('');

        try {
            await sendEmailVerification(user); // Usamos o 'user' do hook
            setSuccess("Um novo link de verificação foi enviado para o seu e-mail.");
            setResendDisabled(true);
            setCountdown(60);
        } catch (err) {
            console.error("Erro ao reenviar e-mail:", err.code);
            // --- TRATAMENTO DE ERRO APRIMORADO ---
            if (err.code === 'auth/too-many-requests') {
                setError("Muitas tentativas de reenvio. Por favor, aguarde um momento antes de tentar novamente.");
            } else {
                setError("Ocorreu um erro ao reenviar o e-mail. Tente novamente mais tarde.");
            }
        }
    };

    return (
        <div className="verify-container">
            <div className="verify-card">
                <div className="verify-icon-wrapper">
                    <FaEnvelopeOpenText size={40} />
                </div>
                <div className="verify-header">
                    <h2>Verifique seu E-mail</h2>
                    <p>Enviamos um link de confirmação para:</p>
                    <span className="verify-email">{email}</span>
                </div>

                <p className="verify-instructions">
                    Por favor, clique no link enviado para ativar sua conta. Lembre-se de checar sua caixa de spam.
                </p>

                {error && <div className="agroauth-error-message">{error}</div>}
                {success && <div className="agroauth-success-message">{success}</div>}

                <button 
                    onClick={handleCheckVerification} 
                    className="agroauth-login-button"
                    disabled={loading}
                >
                    {loading ? <span className="agroauth-spinner"></span> : "Já verifiquei, continuar"}
                </button>

                <button 
                    onClick={handleResendEmail} 
                    className="resend-button"
                    disabled={resendDisabled}
                >
                    {resendDisabled ? `Aguarde ${countdown}s para reenviar` : "Reenviar e-mail de verificação"}
                </button>
            </div>
        </div>
    );
};

export default VerificarEmail;